var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c("div", { staticClass: "notification_box class_question" }, [
          _c(
            "div",
            { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
            [
              _vm.ivdrTotalComponents == _vm.ivdrCurrCtr
                ? _c("div", { staticClass: "padding_rl20 heading" }, [
                    _vm._v(
                      " Performing classification for kit '" +
                        _vm._s(_vm.prodClassCriteria.device_name) +
                        "'. All the components are classified in Kit.Please finalize results to get final classification. "
                    ),
                  ])
                : _c("div", { staticClass: "padding_rl20" }, [
                    _vm._v(
                      " Performing classification for kit '" +
                        _vm._s(_vm.prodClassCriteria.device_name) +
                        "'. Once all the components are classified Kit's class will be derived. "
                    ),
                  ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm.prodClassCriteria.workflowResponseMap &&
    !(_vm.prodClassCriteria.workflowResponseMap.size === 0)
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
            [
              _c(
                "base-collapse",
                {
                  staticClass: "prod-class",
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.activeNames,
                    callback: function ($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames",
                  },
                },
                _vm._l(
                  _vm.prodClassCriteria.workflowResponseMap,
                  function (cache, keyMod) {
                    return _c(
                      "div",
                      { key: keyMod, staticClass: "comp_name" },
                      [
                        _c(
                          "base-collapse-item",
                          {
                            staticClass: "padding_rl20",
                            attrs: {
                              title:
                                "Component '" +
                                cache[1].name +
                                "' of medical kit '" +
                                _vm.prodClassCriteria.device_name +
                                "' is classified  '" +
                                cache[1].classCode +
                                "'",
                              name: cache[1].name,
                            },
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _vm.prodClassCriteria.current_slide_number === 2
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "notification_box question_details",
                                    },
                                    [
                                      _vm.debug === true
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row padding_rl20 class_question",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-5 col-xs-5",
                                                },
                                                [
                                                  _vm._v(
                                                    "Classification Question"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 col-xs-3",
                                                },
                                                [_vm._v("Response")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-1 col-xs-1",
                                                },
                                                [_vm._v("Level")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 col-xs-2",
                                                },
                                                [_vm._v("Interim Class/Class")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-1 col-xs-1",
                                                },
                                                [_vm._v("Rule Ref")]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row padding_rl20 class_question",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 col-xs-8",
                                                },
                                                [
                                                  _vm._v(
                                                    "Classification Question"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-4 col-xs-4",
                                                },
                                                [_vm._v("Response")]
                                              ),
                                            ]
                                          ),
                                      _c("div", {
                                        staticClass: "hr-thin-summary",
                                      }),
                                      _vm._l(
                                        _vm.workflowDataArray(cache[1].cache),
                                        function (data, newIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: newIndex + "_X",
                                              staticClass: "row padding_rl20",
                                              staticStyle: {
                                                "padding-bottom": "5px",
                                              },
                                            },
                                            [
                                              _vm.debug == true
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "class_question_summary",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-5 col-xs-5 class_question_summary",
                                                        },
                                                        [
                                                          keyMod <
                                                          _vm.prodClassCriteria
                                                            .workflowResponseMap
                                                            .size -
                                                            1
                                                            ? _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      data.question
                                                                    ),
                                                                },
                                                              })
                                                            : _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "service",
                                                                  attrs: {
                                                                    href: "javascript:void(0);",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.navigateBack(
                                                                          data.step,
                                                                          keyMod
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          data.question
                                                                        ),
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-redo",
                                                          }),
                                                          _vm.info == true
                                                            ? _c(
                                                                "base-tooltip",
                                                                {
                                                                  attrs: {
                                                                    content: `Click to jump to Step -> ${data.step}`,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "email_tooltip",
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fa fa-question-circle",
                                                                      }),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 col-xs-3",
                                                        },
                                                        [
                                                          data.answer
                                                            ? _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      data.answer
                                                                    ),
                                                                },
                                                              })
                                                            : _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      cache[1]
                                                                        .name
                                                                    ),
                                                                },
                                                              }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-1 col-xs-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(data.level)
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-2 col-xs-2",
                                                        },
                                                        [
                                                          _c("span", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                data.interimClass
                                                              ),
                                                            },
                                                          }),
                                                          !data.classCode
                                                            ? _c("span", [
                                                                _vm._v("/"),
                                                                _c("span", {
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        data.classCode
                                                                      ),
                                                                  },
                                                                }),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-1 col-xs-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(data.ruleRef)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "class_question_summary",
                                                    },
                                                    [
                                                      keyMod <
                                                      _vm.prodClassCriteria
                                                        .workflowResponseMap
                                                        .size -
                                                        1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-md-8 col-xs-8",
                                                            },
                                                            [
                                                              _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      data.question
                                                                    ),
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-md-8 col-xs-8",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "service",
                                                                  attrs: {
                                                                    href: "javascript:void(0);",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.navigateBack(
                                                                          data.step,
                                                                          keyMod
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          data.question
                                                                        ),
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm.info == true
                                                                ? _c(
                                                                    "base-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        content: `Click to Go Back to Step -> ${data.step}`,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "email_tooltip",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fa fa-question-circle",
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fa fa-undo",
                                                                              attrs:
                                                                                {
                                                                                  "aria-hidden":
                                                                                    "true",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4 col-xs-4",
                                                        },
                                                        [
                                                          data.answer
                                                            ? _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      data.answer
                                                                    ),
                                                                },
                                                              })
                                                            : _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      cache[1]
                                                                        .name
                                                                    ),
                                                                },
                                                              }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                              _c("div", {
                                                staticClass:
                                                  "row padding_rl20 hr-thin-separator",
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }